import { useLanguage } from '@/i18n/LanguageContext';
import { RISK_TIER_ZH } from '@/i18n/translateContent';

type RiskTier = 'low' | 'medium' | 'high' | 'critical';

const TIER_CLASSES: Record<RiskTier, string> = {
  low: 'bg-emerald-50 text-emerald-700',
  medium: 'bg-amber-50 text-amber-700',
  high: 'bg-orange-50 text-orange-700',
  critical: 'bg-red-50 text-red-700',
};

const DOT_CLASSES: Record<RiskTier, string> = {
  low: 'bg-emerald-500',
  medium: 'bg-amber-500',
  high: 'bg-orange-500',
  critical: 'bg-red-500',
};

interface RiskBadgeProps {
  tier: string;
  className?: string;
}

export function RiskBadge({ tier, className = '' }: RiskBadgeProps) {
  const { lang } = useLanguage();
  const t = (tier?.toLowerCase() ?? 'low') as RiskTier;
  const classes = TIER_CLASSES[t] || TIER_CLASSES.low;
  const dot = DOT_CLASSES[t] || DOT_CLASSES.low;
  const label = lang === 'zh' ? (RISK_TIER_ZH[t] ?? t) : t;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium capitalize ${classes} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
      {label}
    </span>
  );
}
